// extracted by mini-css-extract-plugin
module.exports = {"Tabber":"Tabber_Tabber__lHUiV","activeLeftHeader":"Tabber_activeLeftHeader__3CWKg","activeRightHeader":"Tabber_activeRightHeader__3rSul"};